import { render, staticRenderFns } from "./doubt.vue?vue&type=template&id=1730cf87&scoped=true&"
import script from "./doubt.vue?vue&type=script&lang=js&"
export * from "./doubt.vue?vue&type=script&lang=js&"
import style0 from "./doubt.vue?vue&type=style&index=0&id=1730cf87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1730cf87",
  null
  
)

export default component.exports